import { createSlice } from '@reduxjs/toolkit'

const basketSlice = createSlice({
    name: 'basket',
    initialState: { loading: false, data: null },
    reducers: {
        setBasketLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        getData() {},
        addTickets() {},
        addTicketsSuccess() {},
        addTicketsError() {},
        removeTicket() {},
        removeTicketSuccess() {},
        removeTicketError() {},
        basketRelease() {},
        basketGetDataRequestFailed() {},
        setBasketData(state, action) {
            const { payload } = action

            if (!payload) {
                return state
            }

            return { ...state, data: payload }
        },
        postMealVoucher(state) {
            state.loading = true
        },
        setMeals(state, action) {
            const { payload } = action
            state.data = { ...payload, items_tickets: state.data?.items_tickets ?? [] }
            state.loading = false
        },
        setCardProlonge(state, action) {
            //Starts the saga witch adds "card prolong" to the basket
            state.loading = true
        },
        setCard(state, action) {
            const { payload } = action
            state.data = { ...payload, items_tickets: state.data?.items_tickets ?? [] }
            state.loading = false
        },
        removeCard(state, action) {
            state.loading = true
        },
        ticketVoucherAdd(state, action) {
            //USED FOR CALLING SAGA ticketVoucherAddSaga
        },
        reInitGiftVoucherBasket() {
            //initializes
        },
        initGiftVoucherBasket() {},
    },
})

const { actions, reducer } = basketSlice

export const {
    getData,
    basketGetDataRequestFailed,
    setBasketData,
    addTickets,
    setBasketLoading,
    addTicketsSuccess,
    addTicketsError,
    removeTicket,
    removeTicketSuccess,
    removeTicketError,
    basketRelease,
    postMealVoucher,
    setMeals,
    setCardProlonge,
    setCard,
    removeCard,
    ticketVoucherAdd,
    initGiftVoucherBasket,
    reInitGiftVoucherBasket,
} = actions

export default reducer
